import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=26d0c3dd&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=26d0c3dd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d0c3dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d0c3dd')) {
      api.createRecord('26d0c3dd', component.options)
    } else {
      api.reload('26d0c3dd', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=26d0c3dd&scoped=true&", function () {
      api.rerender('26d0c3dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/comp/Paginate.vue"
export default component.exports